import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Typography, Grid } from '@sravni/react-design-system';
import { ColSpanAdaptive } from '@sravni/react-design-system/dist/types/components/Grid/types/Col.types';
import { useIsMobile } from '@sravni/react-utils';

import { BANNERS_DATA_NEW } from '../../constants/variant-b-promoCarouse';
import commonStyles from '../../styles/common.module.scss';
import { makeMainGEvent, pushEvent } from '../../utils/analytics';

// import { BigBlock } from './components/Blocks/BigBlock';
import { Card } from './components/Blocks/Card';
// import { SmallBlock } from './components/Blocks/SmallBlock';
import styles from './variant-b-promo-block.module.scss';

export const PromoBlock = React.memo<{ darkTheme: boolean }>(({ darkTheme }) => {
  const [originUrl, setOriginUrl] = useState<string>('');
  const isMobile = useIsMobile();

  useEffect(() => {
    setOriginUrl(document.location.origin);
  }, []);

  const handleClick = useCallback(
    (url: string) => {
      const link = `${originUrl}${url}`;

      try {
        pushEvent(
          makeMainGEvent({
            eventCategory: 'Внутренняя реклама',
            eventAction: link,
            eventLabel: link,
            eventValue: undefined,
          }),
        );
      } catch (error) {
        console.error(error);
      }

      document.location.href = link;
    },
    [originUrl],
  );

  // const blocks = useMemo(() => {
  //   return Object.values(BANNERS_DATA).map((item) => {
  //     const props = {
  //       item,
  //       handleClick,
  //       key: item.key,
  //       darkTheme,
  //     };
  //
  //     if (item.isForm) {
  //       return <BigBlock {...props} />;
  //     }
  //
  //     return <SmallBlock {...props} />;
  //   });
  // }, [darkTheme, handleClick]);

  const spanAdaptive = React.useMemo<ColSpanAdaptive>(() => ({ mobile: 12, tablet: 6, desktop: 4 }), []);

  const columns = useMemo(() => {
    return Object.values(BANNERS_DATA_NEW).map((innerColumns, index) => (
      <Grid.Col key={`columns-${index}`} className={styles.columns} span={spanAdaptive}>
        {innerColumns.rows.map((rows) => (
          <Grid.Row key={`rows-${index}`} gutter={isMobile ? [8, 8] : [16, 16]} wrap={false}>
            {rows.row.map((block) => (
              <Grid.Col key={block.key} className={styles.column} style={block.customStyle}>
                <Card item={block} handleClick={handleClick} darkTheme={darkTheme} isMobile={isMobile} />
              </Grid.Col>
            ))}
          </Grid.Row>
        ))}
      </Grid.Col>
    ));
  }, [darkTheme, handleClick, isMobile, spanAdaptive]);

  return (
    <div className={`${commonStyles.wrapper} ${commonStyles.whiteBackground}`} suppressHydrationWarning>
      <div className={classNames(commonStyles.inner, styles.beforeHeader)}>
        <Typography.Heading level={3} as={'h1'}>
          {/* Вы{'\u00A0'}выбираете, мы{'\u00A0'}помогаем сохранить деньги */}
          Помогаем сохранить деньги
        </Typography.Heading>
        {/*<div className={styles.content}>{blocks}</div>*/}
        <div className={styles.contentNew}>
          <Grid.Row gutter={[isMobile ? 8 : 16, 0]}>{columns}</Grid.Row>
        </div>
      </div>
    </div>
  );
});
